var map = {
	"./coming-soon/art-soon.png": 97496,
	"./coming-soon/art-soon@2x.png": 94903,
	"./coming-soon/art-soon@3x.png": 72101,
	"./default_images/ava_big.png": 77501,
	"./default_images/ava_big@2x.png": 33251,
	"./default_images/shape.png": 4736,
	"./email/status-cancel.png": 88609,
	"./favicons/favicon.ico": 35647,
	"./icons/add.svg": 42271,
	"./icons/alert.svg": 72411,
	"./icons/arrow-back.svg": 25824,
	"./icons/arrow-down.svg": 90994,
	"./icons/attach.svg": 66460,
	"./icons/calendar.svg": 75627,
	"./icons/camera.svg": 69264,
	"./icons/chat.svg": 67485,
	"./icons/chatfull.svg": 38403,
	"./icons/check-off.svg": 78517,
	"./icons/check-on.svg": 90708,
	"./icons/check.svg": 6051,
	"./icons/clew.svg": 28781,
	"./icons/close.svg": 86684,
	"./icons/compare.svg": 64418,
	"./icons/delivery.png": 26011,
	"./icons/done.svg": 62819,
	"./icons/edit.svg": 88908,
	"./icons/eye-off.svg": 5032,
	"./icons/eye-on.svg": 35047,
	"./icons/faq.svg": 98307,
	"./icons/favourite-active.svg": 24903,
	"./icons/favourite.svg": 4979,
	"./icons/fontello/add.svg": 97552,
	"./icons/fontello/alert-bad.svg": 73418,
	"./icons/fontello/alert-good.svg": 70435,
	"./icons/fontello/alert-off.svg": 45322,
	"./icons/fontello/alert-on.svg": 33730,
	"./icons/fontello/arrow-back.svg": 5916,
	"./icons/fontello/arrow-down.svg": 7844,
	"./icons/fontello/arrow-up.svg": 26831,
	"./icons/fontello/attach.svg": 24888,
	"./icons/fontello/attention-1.svg": 93285,
	"./icons/fontello/attention.svg": 27884,
	"./icons/fontello/calendar.svg": 29031,
	"./icons/fontello/camera.svg": 85334,
	"./icons/fontello/chat.svg": 54482,
	"./icons/fontello/chatfull.svg": 14224,
	"./icons/fontello/check-double.svg": 33959,
	"./icons/fontello/check-off.svg": 6970,
	"./icons/fontello/check-on.svg": 17327,
	"./icons/fontello/check-one.svg": 55314,
	"./icons/fontello/check.svg": 74755,
	"./icons/fontello/clew.svg": 45907,
	"./icons/fontello/close.svg": 75635,
	"./icons/fontello/compare.svg": 2723,
	"./icons/fontello/done.svg": 46197,
	"./icons/fontello/edit-1.svg": 23407,
	"./icons/fontello/edit.svg": 24431,
	"./icons/fontello/eye-off.svg": 47401,
	"./icons/fontello/eye-on-1.svg": 7737,
	"./icons/fontello/eye-on.svg": 63250,
	"./icons/fontello/favourite.svg": 79760,
	"./icons/fontello/help.svg": 8334,
	"./icons/fontello/icons-16-create.svg": 5818,
	"./icons/fontello/icons-16-help.svg": 64239,
	"./icons/fontello/icons-20-check.svg": 4215,
	"./icons/fontello/icons-20-dropdown-close.svg": 84442,
	"./icons/fontello/icons-20-dropdown-open.svg": 16546,
	"./icons/fontello/icons-20-sewing.svg": 87490,
	"./icons/fontello/icons-20-stop.svg": 75184,
	"./icons/fontello/icons-20-time.svg": 49012,
	"./icons/fontello/like.svg": 25254,
	"./icons/fontello/lines.svg": 54608,
	"./icons/fontello/minus.svg": 5431,
	"./icons/fontello/more.svg": 56397,
	"./icons/fontello/nophoto.svg": 35940,
	"./icons/fontello/pin-1.svg": 50116,
	"./icons/fontello/pin.svg": 21568,
	"./icons/fontello/remove.svg": 5376,
	"./icons/fontello/sample.svg": 58175,
	"./icons/fontello/search.svg": 96089,
	"./icons/fontello/send.svg": 80516,
	"./icons/fontello/sewing.svg": 86354,
	"./icons/fontello/size-full.svg": 66854,
	"./icons/fontello/stop.svg": 70382,
	"./icons/fontello/thumb-down.svg": 98122,
	"./icons/fontello/thumb-up.svg": 2958,
	"./icons/fontello/thumb.svg": 82462,
	"./icons/fontello/toast-attention.svg": 25984,
	"./icons/fontello/trash.svg": 88931,
	"./icons/fontello/upload.svg": 22436,
	"./icons/fontello/vote.svg": 91350,
	"./icons/fontello/waiting.svg": 32944,
	"./icons/google-disabled.svg": 3514,
	"./icons/google.svg": 71162,
	"./icons/help.svg": 71937,
	"./icons/icon-lines-big.svg": 5849,
	"./icons/icons-lines.svg": 70347,
	"./icons/illustration-120-sample.svg": 41396,
	"./icons/illustration-120-sewing.svg": 73320,
	"./icons/illustration-160-lecalo.svg": 91315,
	"./icons/order.svg": 70691,
	"./icons/pin.svg": 92864,
	"./icons/remove.svg": 52015,
	"./icons/search.svg": 44990,
	"./icons/send.svg": 39381,
	"./icons/sewing.png": 31034,
	"./icons/shape.svg": 26399,
	"./icons/size-full.svg": 90581,
	"./icons/tap.png": 67907,
	"./icons/thumb.svg": 18634,
	"./icons/toast-attention.svg": 83451,
	"./icons/toast-error.svg": 34740,
	"./icons/toast-info.svg": 566,
	"./icons/toast-ok.svg": 25662,
	"./icons/trash.svg": 20610,
	"./icons/verified-grey.svg": 62493,
	"./icons/verified.svg": 48096,
	"./loader/loader.svg": 97212,
	"./logo/logo-cloobok.png": 83589,
	"./logo/logo-cloobok2.png": 77060,
	"./notification/delivery-cancel.svg": 72931,
	"./notification/delivery-done.svg": 75618,
	"./notification/lecalo.png": 82067,
	"./notification/status-gold.svg": 45479,
	"./notification/status-gray.svg": 44256,
	"./notification/status-green.svg": 36295,
	"./notification/status-sample-sewing.svg": 6506,
	"./notification/status-sample.svg": 89586,
	"./notification/status-sewing.svg": 17058,
	"./notification/stop.svg": 35540,
	"./og.png": 60970,
	"coming-soon/art-soon.png": 97496,
	"coming-soon/art-soon@2x.png": 94903,
	"coming-soon/art-soon@3x.png": 72101,
	"default_images/ava_big.png": 77501,
	"default_images/ava_big@2x.png": 33251,
	"default_images/shape.png": 4736,
	"email/status-cancel.png": 88609,
	"favicons/favicon.ico": 35647,
	"icons/add.svg": 42271,
	"icons/alert.svg": 72411,
	"icons/arrow-back.svg": 25824,
	"icons/arrow-down.svg": 90994,
	"icons/attach.svg": 66460,
	"icons/calendar.svg": 75627,
	"icons/camera.svg": 69264,
	"icons/chat.svg": 67485,
	"icons/chatfull.svg": 38403,
	"icons/check-off.svg": 78517,
	"icons/check-on.svg": 90708,
	"icons/check.svg": 6051,
	"icons/clew.svg": 28781,
	"icons/close.svg": 86684,
	"icons/compare.svg": 64418,
	"icons/delivery.png": 26011,
	"icons/done.svg": 62819,
	"icons/edit.svg": 88908,
	"icons/eye-off.svg": 5032,
	"icons/eye-on.svg": 35047,
	"icons/faq.svg": 98307,
	"icons/favourite-active.svg": 24903,
	"icons/favourite.svg": 4979,
	"icons/fontello/add.svg": 97552,
	"icons/fontello/alert-bad.svg": 73418,
	"icons/fontello/alert-good.svg": 70435,
	"icons/fontello/alert-off.svg": 45322,
	"icons/fontello/alert-on.svg": 33730,
	"icons/fontello/arrow-back.svg": 5916,
	"icons/fontello/arrow-down.svg": 7844,
	"icons/fontello/arrow-up.svg": 26831,
	"icons/fontello/attach.svg": 24888,
	"icons/fontello/attention-1.svg": 93285,
	"icons/fontello/attention.svg": 27884,
	"icons/fontello/calendar.svg": 29031,
	"icons/fontello/camera.svg": 85334,
	"icons/fontello/chat.svg": 54482,
	"icons/fontello/chatfull.svg": 14224,
	"icons/fontello/check-double.svg": 33959,
	"icons/fontello/check-off.svg": 6970,
	"icons/fontello/check-on.svg": 17327,
	"icons/fontello/check-one.svg": 55314,
	"icons/fontello/check.svg": 74755,
	"icons/fontello/clew.svg": 45907,
	"icons/fontello/close.svg": 75635,
	"icons/fontello/compare.svg": 2723,
	"icons/fontello/done.svg": 46197,
	"icons/fontello/edit-1.svg": 23407,
	"icons/fontello/edit.svg": 24431,
	"icons/fontello/eye-off.svg": 47401,
	"icons/fontello/eye-on-1.svg": 7737,
	"icons/fontello/eye-on.svg": 63250,
	"icons/fontello/favourite.svg": 79760,
	"icons/fontello/help.svg": 8334,
	"icons/fontello/icons-16-create.svg": 5818,
	"icons/fontello/icons-16-help.svg": 64239,
	"icons/fontello/icons-20-check.svg": 4215,
	"icons/fontello/icons-20-dropdown-close.svg": 84442,
	"icons/fontello/icons-20-dropdown-open.svg": 16546,
	"icons/fontello/icons-20-sewing.svg": 87490,
	"icons/fontello/icons-20-stop.svg": 75184,
	"icons/fontello/icons-20-time.svg": 49012,
	"icons/fontello/like.svg": 25254,
	"icons/fontello/lines.svg": 54608,
	"icons/fontello/minus.svg": 5431,
	"icons/fontello/more.svg": 56397,
	"icons/fontello/nophoto.svg": 35940,
	"icons/fontello/pin-1.svg": 50116,
	"icons/fontello/pin.svg": 21568,
	"icons/fontello/remove.svg": 5376,
	"icons/fontello/sample.svg": 58175,
	"icons/fontello/search.svg": 96089,
	"icons/fontello/send.svg": 80516,
	"icons/fontello/sewing.svg": 86354,
	"icons/fontello/size-full.svg": 66854,
	"icons/fontello/stop.svg": 70382,
	"icons/fontello/thumb-down.svg": 98122,
	"icons/fontello/thumb-up.svg": 2958,
	"icons/fontello/thumb.svg": 82462,
	"icons/fontello/toast-attention.svg": 25984,
	"icons/fontello/trash.svg": 88931,
	"icons/fontello/upload.svg": 22436,
	"icons/fontello/vote.svg": 91350,
	"icons/fontello/waiting.svg": 32944,
	"icons/google-disabled.svg": 3514,
	"icons/google.svg": 71162,
	"icons/help.svg": 71937,
	"icons/icon-lines-big.svg": 5849,
	"icons/icons-lines.svg": 70347,
	"icons/illustration-120-sample.svg": 41396,
	"icons/illustration-120-sewing.svg": 73320,
	"icons/illustration-160-lecalo.svg": 91315,
	"icons/order.svg": 70691,
	"icons/pin.svg": 92864,
	"icons/remove.svg": 52015,
	"icons/search.svg": 44990,
	"icons/send.svg": 39381,
	"icons/sewing.png": 31034,
	"icons/shape.svg": 26399,
	"icons/size-full.svg": 90581,
	"icons/tap.png": 67907,
	"icons/thumb.svg": 18634,
	"icons/toast-attention.svg": 83451,
	"icons/toast-error.svg": 34740,
	"icons/toast-info.svg": 566,
	"icons/toast-ok.svg": 25662,
	"icons/trash.svg": 20610,
	"icons/verified-grey.svg": 62493,
	"icons/verified.svg": 48096,
	"images/coming-soon/art-soon.png": 97496,
	"images/coming-soon/art-soon@2x.png": 94903,
	"images/coming-soon/art-soon@3x.png": 72101,
	"images/default_images/ava_big.png": 77501,
	"images/default_images/ava_big@2x.png": 33251,
	"images/default_images/shape.png": 4736,
	"images/email/status-cancel.png": 88609,
	"images/favicons/favicon.ico": 35647,
	"images/icons/add.svg": 42271,
	"images/icons/alert.svg": 72411,
	"images/icons/arrow-back.svg": 25824,
	"images/icons/arrow-down.svg": 90994,
	"images/icons/attach.svg": 66460,
	"images/icons/calendar.svg": 75627,
	"images/icons/camera.svg": 69264,
	"images/icons/chat.svg": 67485,
	"images/icons/chatfull.svg": 38403,
	"images/icons/check-off.svg": 78517,
	"images/icons/check-on.svg": 90708,
	"images/icons/check.svg": 6051,
	"images/icons/clew.svg": 28781,
	"images/icons/close.svg": 86684,
	"images/icons/compare.svg": 64418,
	"images/icons/delivery.png": 26011,
	"images/icons/done.svg": 62819,
	"images/icons/edit.svg": 88908,
	"images/icons/eye-off.svg": 5032,
	"images/icons/eye-on.svg": 35047,
	"images/icons/faq.svg": 98307,
	"images/icons/favourite-active.svg": 24903,
	"images/icons/favourite.svg": 4979,
	"images/icons/fontello/add.svg": 97552,
	"images/icons/fontello/alert-bad.svg": 73418,
	"images/icons/fontello/alert-good.svg": 70435,
	"images/icons/fontello/alert-off.svg": 45322,
	"images/icons/fontello/alert-on.svg": 33730,
	"images/icons/fontello/arrow-back.svg": 5916,
	"images/icons/fontello/arrow-down.svg": 7844,
	"images/icons/fontello/arrow-up.svg": 26831,
	"images/icons/fontello/attach.svg": 24888,
	"images/icons/fontello/attention-1.svg": 93285,
	"images/icons/fontello/attention.svg": 27884,
	"images/icons/fontello/calendar.svg": 29031,
	"images/icons/fontello/camera.svg": 85334,
	"images/icons/fontello/chat.svg": 54482,
	"images/icons/fontello/chatfull.svg": 14224,
	"images/icons/fontello/check-double.svg": 33959,
	"images/icons/fontello/check-off.svg": 6970,
	"images/icons/fontello/check-on.svg": 17327,
	"images/icons/fontello/check-one.svg": 55314,
	"images/icons/fontello/check.svg": 74755,
	"images/icons/fontello/clew.svg": 45907,
	"images/icons/fontello/close.svg": 75635,
	"images/icons/fontello/compare.svg": 2723,
	"images/icons/fontello/done.svg": 46197,
	"images/icons/fontello/edit-1.svg": 23407,
	"images/icons/fontello/edit.svg": 24431,
	"images/icons/fontello/eye-off.svg": 47401,
	"images/icons/fontello/eye-on-1.svg": 7737,
	"images/icons/fontello/eye-on.svg": 63250,
	"images/icons/fontello/favourite.svg": 79760,
	"images/icons/fontello/help.svg": 8334,
	"images/icons/fontello/icons-16-create.svg": 5818,
	"images/icons/fontello/icons-16-help.svg": 64239,
	"images/icons/fontello/icons-20-check.svg": 4215,
	"images/icons/fontello/icons-20-dropdown-close.svg": 84442,
	"images/icons/fontello/icons-20-dropdown-open.svg": 16546,
	"images/icons/fontello/icons-20-sewing.svg": 87490,
	"images/icons/fontello/icons-20-stop.svg": 75184,
	"images/icons/fontello/icons-20-time.svg": 49012,
	"images/icons/fontello/like.svg": 25254,
	"images/icons/fontello/lines.svg": 54608,
	"images/icons/fontello/minus.svg": 5431,
	"images/icons/fontello/more.svg": 56397,
	"images/icons/fontello/nophoto.svg": 35940,
	"images/icons/fontello/pin-1.svg": 50116,
	"images/icons/fontello/pin.svg": 21568,
	"images/icons/fontello/remove.svg": 5376,
	"images/icons/fontello/sample.svg": 58175,
	"images/icons/fontello/search.svg": 96089,
	"images/icons/fontello/send.svg": 80516,
	"images/icons/fontello/sewing.svg": 86354,
	"images/icons/fontello/size-full.svg": 66854,
	"images/icons/fontello/stop.svg": 70382,
	"images/icons/fontello/thumb-down.svg": 98122,
	"images/icons/fontello/thumb-up.svg": 2958,
	"images/icons/fontello/thumb.svg": 82462,
	"images/icons/fontello/toast-attention.svg": 25984,
	"images/icons/fontello/trash.svg": 88931,
	"images/icons/fontello/upload.svg": 22436,
	"images/icons/fontello/vote.svg": 91350,
	"images/icons/fontello/waiting.svg": 32944,
	"images/icons/google-disabled.svg": 3514,
	"images/icons/google.svg": 71162,
	"images/icons/help.svg": 71937,
	"images/icons/icon-lines-big.svg": 5849,
	"images/icons/icons-lines.svg": 70347,
	"images/icons/illustration-120-sample.svg": 41396,
	"images/icons/illustration-120-sewing.svg": 73320,
	"images/icons/illustration-160-lecalo.svg": 91315,
	"images/icons/order.svg": 70691,
	"images/icons/pin.svg": 92864,
	"images/icons/remove.svg": 52015,
	"images/icons/search.svg": 44990,
	"images/icons/send.svg": 39381,
	"images/icons/sewing.png": 31034,
	"images/icons/shape.svg": 26399,
	"images/icons/size-full.svg": 90581,
	"images/icons/tap.png": 67907,
	"images/icons/thumb.svg": 18634,
	"images/icons/toast-attention.svg": 83451,
	"images/icons/toast-error.svg": 34740,
	"images/icons/toast-info.svg": 566,
	"images/icons/toast-ok.svg": 25662,
	"images/icons/trash.svg": 20610,
	"images/icons/verified-grey.svg": 62493,
	"images/icons/verified.svg": 48096,
	"images/loader/loader.svg": 97212,
	"images/logo/logo-cloobok.png": 83589,
	"images/logo/logo-cloobok2.png": 77060,
	"images/notification/delivery-cancel.svg": 72931,
	"images/notification/delivery-done.svg": 75618,
	"images/notification/lecalo.png": 82067,
	"images/notification/status-gold.svg": 45479,
	"images/notification/status-gray.svg": 44256,
	"images/notification/status-green.svg": 36295,
	"images/notification/status-sample-sewing.svg": 6506,
	"images/notification/status-sample.svg": 89586,
	"images/notification/status-sewing.svg": 17058,
	"images/notification/stop.svg": 35540,
	"images/og.png": 60970,
	"loader/loader.svg": 97212,
	"logo/logo-cloobok.png": 83589,
	"logo/logo-cloobok2.png": 77060,
	"notification/delivery-cancel.svg": 72931,
	"notification/delivery-done.svg": 75618,
	"notification/lecalo.png": 82067,
	"notification/status-gold.svg": 45479,
	"notification/status-gray.svg": 44256,
	"notification/status-green.svg": 36295,
	"notification/status-sample-sewing.svg": 6506,
	"notification/status-sample.svg": 89586,
	"notification/status-sewing.svg": 17058,
	"notification/stop.svg": 35540,
	"og.png": 60970
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41001;